import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  FormControlLabel,
  Switch,
  Paper,
  Divider,
} from "@mui/material";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import SelectInput from "../../Components/InputComponents/SelectInput";
import { successNotify } from "../../Components/ToastComponent/ToastNotification";

const ClientFieldPrivilege = () => {
  const [selectedRole, setSelectedRole] = useState("");
  const [roles, setRoles] = useState([]);

  const [formFields, setFormFields] = useState([]);

  const [secretFields, setSecretFields] = useState([]);

  const handleToggle = (field) => {
    const fieldIdStr = field.fieldID; // always use string

    setSecretFields((prev) => {
      const exists = prev.find((f) => f.fieldName == fieldIdStr);

      if (exists) {
        return prev.map((f) =>
          f.fieldName == fieldIdStr
            ? { ...f, allowed: f.allowed == 1 ? 0 : 1 }
            : f
        );
      } else {
        return [
          ...prev,
          {
            fieldName: fieldIdStr,
            allowed: 1,
          },
        ];
      }
    });
  };

  const getEmployeeRoleList = async () => {
    try {
      const res = await axiosAPI.get(`/UserRole/list/active`);
      setRoles(res?.data?.data || []);

      if (res?.data?.data?.length > 0) {
        setSelectedRole(res?.data?.data[0]?.RL_Id);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getFieldList = async () => {
    try {
      const res = await axiosAPI.get(`/Privilege/clientfields`);
      setFormFields(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getClientPrivilages = async () => {
    try {
      const res = await axiosAPI.get(
        `/Privilege/clientprivileges/${selectedRole}`
      );

      const originalData = res?.data?.data || [];

      // Remove duplicates based on fieldName
      const uniqueData = Array.from(
        new Map(
          originalData.map((item) => [String(item.fieldName), item])
        ).values()
      );

      setSecretFields(uniqueData);
    } catch (err) {
      console.error(err);
    }
  };

  const savefn = async () => {
    try {
      const res = await axiosAPI.post(`/Privilege/clientprivilege/save`, {
        roleId: selectedRole,
        fieldPrivileges: secretFields,
      });

      if (res?.data?.data?.success) {
        successNotify(res?.data?.data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getEmployeeRoleList();
    getFieldList();
  }, []);

  useEffect(() => {
    if (selectedRole) {
      getClientPrivilages();
    }
  }, [selectedRole]);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        mb={3}
      >
        Client privileges
      </Typography>

      <Grid container spacing={2} xs={12}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Role <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
            options={roles?.map((item) => ({
              value: item?.RL_Id,
              label: item?.RL_Name,
            }))}
            placeholder="Select Role"
          />
        </Grid>
      </Grid>

      <Paper sx={{ p: 3, my: 2, boxShadow:"none", border:'1px solid lightgrey' }}>
        <Grid container sx={{ py: 1, alignItems: "center" }}>
          {formFields?.map((field, index) => {
            const fieldIdStr = field.fieldID;
            const matchedField = secretFields.find(
              (f) => f.fieldName == fieldIdStr
            );
            const isChecked = matchedField?.allowed == 1;

            return (
              <Grid container item xs={12} sm={6} md={4} lg={3} key={index}>
                <Grid item xs={8}>
                  <Typography sx={{ fontFamily: "Geist, sans-serif" }}>
                    {field?.displayName}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isChecked}
                        onChange={() => handleToggle(field)}
                        color="primary"
                      />
                    }
                    label=""
                  />
                </Grid>
              </Grid>
            );
          })}
        </Grid>

        <Grid
          container
          spacing={2}
          justifyContent={{ xs: "center", sm: "flex-end" }}
          sx={{ mt: 3 }}
        >
          <Grid item>
            <CommonButton
              variant="contained"
              customColor="#007BFF"
              onClick={savefn}
            >
              Save
            </CommonButton>
          </Grid>
        </Grid>
      </Paper>
    </Paper>
  );
};

export default ClientFieldPrivilege;
